import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
<section className="banner">
  <div className='content'>

    <Heading title={"Savor Sweet Moments with Us!"} subTitle={"Sweeten Every Day"} linear />
    <p>Indulge in a delightful world of freshly baked goods and treats. Our artisan bakers are here to make your moments sweeter with our special offer.</p>
    <Button link={"Shop-Grid"} title={"Explore Our Products"} />

  </div>
</section>

  );

};

export default Banner;